<div class="booble-backdrop">
  <div class="xp-modal xp-modal-cadastro">
    <div
      class="modal-dialog modal-xl modal-dialog-centered modal--xl modal--lg modal--md modal--sm"
    >
      <div class="modal-content">
        <div class="modal-dialog-scrollable-general">
          <div class="modal-header">
            <div
              class="col-md-12 d-flex justify-content-between modal-header-border"
            >
              <div>
                <div class="modal-title-new">
                  Confirma a exclusão deste contato?
                </div>
              </div>

              <div
                (click)="closeModal()"
                class="close-icon tappable align-self-center"
              >
                <img src="assets/image/close-modal-icon.svg" />
              </div>
            </div>
          </div>

          <div class="modal-body-content">
            <p class="p-text-grey font-weight-300 mg-top-8">
              Após a exclusão, ainda será possível enviar ou receber pagamentos
              relacionados a este contato, porém suas informações não estarão
              mais salvas na plataforma.
            </p>
          </div>
        </div>

        <div class="modal-footer-new">
          <button
            type="button"
            (click)="closeModal()"
            [style.width]="'95px'"
            class="btn-outline-primary btn"
            type="button"
          >
            Não
          </button>
          <button
            type="button"
            [disabled]="loading"
            (click)="confirm(boobleModalData)"
            class="btn-footer btn"
            [ngClass]="
              companyId ? 'btn-dark-primary-blue' : 'btn-dark-primary-blue-pf'
            "
            type="button"
          >
            Sim, confirmo
            <span
              class="spinner-border spinner-border-sm"
              *ngIf="loading"
            ></span>
          </button>
        </div>
      </div>
    </div>
  </div>
</div>
